export default __webpack_public_path__ + "static/2-b01e55414f421017fd4dc8d657553b81.jpeg";